// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"L7-z"};